// 3rd-party
import React from 'react';

// Components
import { PrimaryButton } from '../buttons';
import { Input } from '../inputs';
import Modal from '@/views/components/modals/AccessibleModal';
import { Typography } from '@capintel/component-lib/typography';
import { Stack } from '@capintel/component-lib/stack';

// Utils
import { FormattedMessage, formatMessage } from '../../../utils/i18n';
import { capitalizeFirst } from '../../../utils/strings';

// Assets
import confirmCheck from '../../../images/confirm-check.svg';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  showModal: boolean;
  url?: string;
  type: string;
};

class GeneratedLinkModal extends React.PureComponent<Props> {
  private inputRef = React.createRef<Input>();

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.url && this.props.url) {
      this.copyText();
    }
  }

  copyText = () => {
    if (this.inputRef.current) {
      this.inputRef.current.selectAll();
      document.execCommand('copy');
    }
  };

  render() {
    const { onCancel, onConfirm, showModal, url, type } = this.props;

    return (
      <Modal show={showModal} className="invite-modal generated-link-modal" onHide={onCancel} dialogClassName="modal-dialog-centered">
        <Modal.Header className="d-flex flex-column align-items-center">
          <Stack gap="400">
            <i className="icon-cross" onClick={onCancel} />
            <img className="confirm-check" src={confirmCheck} alt="" />
            <Typography variant="headerLg" as="h1">
              <FormattedMessage id="GeneratedLinkModal.Title" values={{ type: formatMessage(`Common.${capitalizeFirst(type)}`).toLowerCase() }} />
            </Typography>
          </Stack>
        </Modal.Header>
        <Modal.Body>
          <Input ref={this.inputRef} className="w-100" type="text" readOnly value={url} data-private data-dd-privacy="mask" />
        </Modal.Body>

        <Modal.Footer className="d-flex flex-column align-items-center">
          <PrimaryButton className="submit-button" onClick={onConfirm}>
            <FormattedMessage id="Common.Done" />
          </PrimaryButton>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default GeneratedLinkModal;
